package com.xtream.data_kmp.remote.repo

 import com.xtream.data_kmp.remote.ApiService
 import com.xtream.data_kmp.PreferencesRepo
 import com.xtream.data_kmp.dto.ServerConfig
 import com.xtream.data_kmp.remote.createApiService
import io.ktor.client.statement.bodyAsText
import io.ktor.http.isSuccess
import kotlinx.coroutines.flow.firstOrNull
import kotlinx.serialization.json.Json
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

class ServerConfigRepo(
    private val appSettingsRepo: PreferencesRepo,
 ){
    @OptIn(ExperimentalEncodingApi::class)
    suspend fun fetchAndStoreServerConfig(baseUrl: String): Result<ServerConfig> {
         val apiService: ApiService = createApiService(baseUrl)

        val json: Json= ApiService.jsonObj
        return try {
            val response = apiService.getServerConfigs()

            if (response.status.isSuccess()) {
                val base64Body = response.bodyAsText()
                val decoded = Base64.Default.decode(base64Body)
                val body = json.decodeFromString<ServerConfig>(decoded.decodeToString())
                with(appSettingsRepo) {
                    editPref(PreferencesRepo.ACTIVATION_SERVER_URL_KEY, body.serverUrl ?: "")
                    editPref(PreferencesRepo.ACCOUNT_SERVER_URL_KEY, body.accountServerUrl ?: "")
                    editPref(PreferencesRepo.ACTIVATION_XOR_KEY, body.xorKey ?: "")
                    editPref(PreferencesRepo.SERVER_USER_AGENT_KEY, body.userAgent ?: "")
                    editPref(PreferencesRepo.SERVER_TMDB_KEY, body.tmdbKey ?: "")
                    editPref(PreferencesRepo.SUBTITLE_KEY, body.subtitleKey ?: "")
                    editPref(PreferencesRepo.SUBTITLE_SERVER, body.subtitleServer ?: "")
                    editPref(PreferencesRepo.TRIAL_USER, body.trialUsername ?: "")
                    editPref(PreferencesRepo.TRIAL_PASS, body.trialPassword ?: "")
                }

                Result.success(body)
            } else {
                Result.failure(Throwable("Error code ${response.status}"))
            }

        } catch (e: Exception) {
           // Log.d("ServerConfigRepo", "fetchAndStoreServerConfig: $e")

            val cache = appSettingsRepo.readFromDataStore.firstOrNull()
            if (cache?.accountServerUrl != null && cache.activationServerUrl != null)
                Result.success(readCachedServerConfig(cache))
            else
                Result.failure(e)
        }
    }
    private fun readCachedServerConfig(cached: PreferencesRepo.UserPreferences): ServerConfig {

        return ServerConfig(
            serverUrl = cached.activationServerUrl,
            accountServerUrl = cached.accountServerUrl,
            xorKey = cached.activationXORKey,
            userAgent = cached.serverUserAgent,
            tmdbKey = cached.serverTMDBKey,
            subtitleKey = cached.subtitleKey,
            subtitleServer = cached.subtitleServer,
            trialUsername = cached.trialUsername,
            trialPassword = cached.trialPassword,
        )
    }
}